<template>
  <cliente-dialog @close="close"></cliente-dialog>
</template>

<script>
    import ClienteDialog from "@/components/clientes/ClienteDialog.vue";
    export default {
        name: 'ClientesShow',
        components: {
            ClienteDialog,
        },
        methods: {
            close(){
                this.$router.push({
                    name: 'clientes'
                });
            }
        },
    }
</script>